<div>
  <label *ngIf="label" [attr.for]="identifier">{{label}}</label>
  <input [maxlength]="tamanhoMaximo" currencyMask [(ngModel)]="value" [id]="identifier" [readonly]="readonly" [disabled]="disabled"
    [(ngModel)]="value" [options]="options" [type]="type" [placeholder]="placeholder || ''" [ngClass]="{'form-control': true, invalid: (invalid | async)}"
    (ngModelChange)="correctNaN($event)" (blur)="blur.emit($event)" (keyup)="keyup.emit($event)" [autocomplete]="autocomplete"
  />
  <validation [elementBase]="this"></validation>
</div>



// WEBPACK FOOTER //
// ./src/deps/pmv-common/pmv-common.d.ts.ɵo.html